
import ServiceBanner from "../components/Services/ServiceBanner";
import OurSevicesList from "../components/Services/OurSevicesList";

const Servicespage = () => {

  
  return (
    <>
<ServiceBanner/>
<OurSevicesList/>
    </>
  );
};

export default Servicespage;
